// extracted by mini-css-extract-plugin
export default {"container":"Ar3QYB","overrideMargin":"rSLXLV"};